<div class="flex-container" [style.maxWidth]="maxWidth" [style.margin]="margin" [ngClass]="classesArray"><ng-content></ng-content></div>
